import type { AuthStore } from '@stores/auth/interfaces'
import type { AuthTokens } from '@brighterly/lib-core-types/login/interfaces'

import { AppRoute } from '@ts-routes/enums'
import { AuthDisplay } from '@brighterly/lib-core-types/login/enums'

import { _applyTokens } from '@auth/apply-tokens'
import { _hydrateFromStorage } from '@auth/hydrate-from-storage'
import { _clearTokens } from '@auth/clear-tokens'
import { refreshTokens } from '@auth/refresh-tokens'

const setAuthDisplay = (state: AuthStore, payload: AuthStore['authDisplay']): void => {
  state.authDisplay = payload
}
const setPhone = (state: AuthStore, payload: AuthStore['phone']): void => {
  state.phone = payload
}
const setEmail = (state: AuthStore, payload: AuthStore['email']): void => {
  state.email = payload
}
const setOtpCode = (state: AuthStore, payload: AuthStore['otpCode']): void => {
  state.otpCode = payload
}
const setPhoneValid = (state: AuthStore, payload: AuthStore['phoneValid']): void => {
  state.phoneValid = payload
}

const setEmailValid = (state: AuthStore, payload: AuthStore['emailValid']): void => {
  state.emailValid = payload
}

const setResetAuth = (state: AuthStore): void => {
  setAuthDisplay(state, AuthDisplay.Login)
  setPhone(state, '')
  setEmail(state, '')
  setOtpCode(state, '')
  setPhoneValid(state, false)
  setEmailValid(state, false)
}

const setResetSession = (state: AuthStore): void => {
  setResetAuth(state)
  _clearTokens(state)
}

export const actions = {
  setLoading (this: AuthStore, payload: AuthStore['loading']): void {
    this.loading = payload
  },
  setAuthMethod (this: AuthStore, payload: AuthStore['authMethod']): void {
    this.authMethod = payload
  },
  setAuthDisplay (this: AuthStore, payload: AuthStore['authDisplay']): void {
    return setAuthDisplay(this, payload)
  },
  setOtpCode (this: AuthStore, payload: AuthStore['otpCode']): void {
    return setOtpCode(this, payload)
  },
  setOtpError (this: AuthStore, payload: AuthStore['otpError']): void {
    this.otpError = payload
  },
  setOtpReSend (this: AuthStore, payload: AuthStore['otpReSend']): void {
    this.otpReSend = payload
  },
  setPhone (this: AuthStore, payload: AuthStore['phone']): void {
    return setPhone(this, payload)
  },
  setPhoneValid (this: AuthStore, payload: AuthStore['phoneValid']): void {
    return setPhoneValid(this, payload)
  },
  setEmail (this: AuthStore, payload: AuthStore['email']): void {
    return setEmail(this, payload)
  },
  setEmailValid (this: AuthStore, payload: AuthStore['emailValid']): void {
    return setEmailValid(this, payload)
  },
  reset (this: AuthStore): void {
    return setResetSession(this)
  },
  async logout (this: AuthStore): Promise<void> {
    setResetSession(this)
    await navigateTo(AppRoute.Login)
  },
  refreshTokens (this: AuthStore): Promise<string | void> {
    return refreshTokens(this)
  },
  /** Private methods */
  _applyTokens (this: AuthStore, payload: AuthTokens): void {
    return _applyTokens(this, payload)
  },
  _clearTokens (this: AuthStore): void {
    return _clearTokens(this)
  },
  _hydrateFromStorage (this: AuthStore): void {
    return _hydrateFromStorage(this)
  },
}
